export default "__VITE_ASSET__CdsFQ5Oy__"